import { createFileRoute } from '@tanstack/react-router'

import { QaDashboard } from '@/components/bugs/qa-dashboard'
import { PageHeader } from '@/components/page-header'
import { useBarSync } from '@/hooks/use-bar-sync'
import { matching, oneOf, readSearch } from '@/lib/search-params'

const ID = /^[0-9a-f]{24}$/

/** Lot 47 : le tableau de bord QA — bugs ouverts et fermés, progression, à vérifier. */
export const Route = createFileRoute('/_app/qa/')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        client: matching(ID),
        // Lot 47 : un projet, ou `none` pour les bugs sans projet.
        projet: matching(/^([0-9a-f]{24}|none)$/),
        periode: oneOf(['7', '30', '90'] as const),
      },
      search,
    ),
  component: QaDashboardPage,
})

function QaDashboardPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  // #401 : le client et le projet de la barre sont les filtres de la page.
  useBarSync(search, (next) => {
    void navigate({
      search: (current) => ({ ...current, client: next.client, projet: next.projet }),
      replace: true,
    })
  })
  return (
    <div className="space-y-6">
      <PageHeader title="QA" documentTitle="QA — bugs" />
      <QaDashboard
        search={search}
        onSearchChange={(next) => {
          void navigate({ search: (current) => ({ ...current, ...next }), replace: true })
        }}
      />
    </div>
  )
}
